import React from 'react'
import ErrorMessage from './ErrorMessage'

function DynamicListMainFieldsUi(props) {
  const {
    listData,
    GetPersons,
    previewData,
    headerLevelPersons,
    removePersonFromHeaderTaggedPersons,
    Name,
    handleNameChange,
    SelectionFromSuggestion,
    filteredNames,
    imageValue,
    handleImage,
    dynamicListImage,
    getSrcValue,
    imageHorizontal,
    horizontalImagePresent,
    handleListData,
    duplicate,
    ClearAllHeaderLevelPersons,
    requiredImageSize,
  } = props
  return (
    <div>
      <div className='row'>
        <div className='form-group col-md-6'>
          <label htmlFor='dynamicListtitle_En'>Title_En</label>
          <input
            type='text'
            className='form-control'
            id='dynamicListtitle_En'
            aria-describedby='emailHelp'
            placeholder='Enter title in english'
            value={listData.title_En}
            onChange={e => handleListData('title_En', e.target.value)}
          />
          {!listData.title_En && <ErrorMessage error={'Enter title in english'} />}
        </div>
        <div className='form-group col-md-6'>
          <label htmlFor='dynamicListtitle_Te'>Title_Te</label>
          <input
            type='text'
            className='form-control'
            id='dynamicListtitle_Te'
            aria-describedby='emailHelp'
            placeholder='Enter title in telugu '
            value={listData.title_Te}
            onChange={e => handleListData('title_Te', e.target.value)}
          />
          {!listData.title_Te && <ErrorMessage error={'Enter title in telugu'} />}
          {/* <ErrorMessage error={'Enter title in english'} /> */}
        </div>
      </div>
      <div className='row'>
        <div className='form-group col-md-6'>
          <label htmlFor='dynamicListdescription_En'>Description_En</label>
          <textarea
            // type='textarea'
            rows={8}
            cols={50}
            className='form-control'
            id='dynamicListdescription_En'
            aria-describedby='emailHelp'
            placeholder='Enter description in english'
            value={listData.description_En}
            onChange={e => handleListData('description_En', e.target.value)}
          />
          {!listData.description_En && <ErrorMessage error={'Enter description in english'} />}
        </div>
        <div className='form-group col-md-6'>
          <label htmlFor='dynamicListdescription_Te'>Description_Te</label>
          <textarea
            // type='text'
            rows={8}
            cols={50}
            className='form-control'
            id='dynamicListdescription_Te'
            aria-describedby='emailHelp'
            placeholder='Enter description in telugu'
            value={listData.description_Te}
            onChange={e => handleListData('description_Te', e.target.value)}
          />
          {!listData.description_Te && <ErrorMessage error={'Enter description in telugu'} />}
        </div>
      </div>

      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <label>HeaderLevel TaggedPersons:</label>
        <div style={{ display: 'flex', gap: '10px' }}>
            {previewData && previewData.length >= 1 && listData.dynamicListType !== 'trendingLists' && (
                <button
                  type='button'
                  className='btn btn-primary'
                  style={{ margin: '10px', float: 'right' }}
                  onClick={() => GetPersons()}
                >
                  GetTagPersons
                </button>
              )}
              {headerLevelPersons && headerLevelPersons.length >= 1 && (
                <button
                  type='button'
                  className='btn btn-primary'
                  style={{ margin: '10px', float: 'right' }}
                  onClick={() => ClearAllHeaderLevelPersons()}
                >
                  Clear All
                </button>
              )}
          </div>
        </div>
        {headerLevelPersons && headerLevelPersons.length >= 1 && (
          <div
            className='card'
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '0.3rem',
              padding: '1rem',
            }}
          >
            {headerLevelPersons &&
              headerLevelPersons.map(
                (persons, personsIndex) => (
                  // persons.map((person, personIndex) => (
                  <div className='TaggedPersonData' key={personsIndex}>
                    <div
                      style={{
                        borderRadius: '1rem',
                        backgroundColor: '#ededed',
                      }}
                      className='d-flex justify-content-start align-items-center pl-2 pr-2 mt-1 mb-1'
                    >
                      <span className='mr-2'>{persons.name_En} </span>
                      <span
                        style={{
                          borderRadius: '50%',
                          color: 'white',
                          backgroundColor: '#474747',
                          padding: '2px 5px',
                          fontSize: '8px',
                        }}
                        onClick={() =>
                          removePersonFromHeaderTaggedPersons(personsIndex, persons.personID)
                        }
                      >
                        X
                      </span>
                    </div>
                  </div>
                ),
                // )),
              )}
          </div>
        )}
        {duplicate && <span className='mandatory1'>Person Already Exists</span>}
        <div>
          {
            <input
              type={'text'}
              className='form-control'
              style={{ width: '50%' }}
              // style={props.modeUrl && indication}
              value={Name}
              onChange={e => handleNameChange(e.target.value)}
            ></input>
          }
          {filteredNames.length >= 1 && (
            <div className='searchfield' style={{ width: '28%' }}>
              {filteredNames.map((Name, NameIndex) => (
                <div key={NameIndex} onClick={event => SelectionFromSuggestion(event)}>
                  <label>{Name.label}</label>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className='d-flex'>
        <div className='mb-3'>
          <label htmlFor='formFile' className='form-label'>
            Upload Image
          </label>
          <input
            className='form-control'
            value={imageValue}
            onChange={handleImage}
            type='file'
            id='formFile'
          />
          {dynamicListImage && (
            <div
              style={{ height: '12rem', border: '1px solid #8f8f8f', position: 'relative' }}
              className='mt-2 mb-2 p-2'
            >
              <img
                style={{ height: '100%', width: '100%', objectFit: 'contain' }}
                src={getSrcValue(dynamicListImage)}
                alt='image'
                onLoad={e => imageHorizontal(e)}
              />
              <span
                onClick={() => handleListData('dynamicListImage', '')}
                className=''
                style={{
                  fontSize: '14px',
                  position: 'absolute',
                  right: '1rem',
                  top: '0.5rem',
                  backgroundColor: '#cbcbcb',
                  padding: '4px 10px',
                  borderRadius: '50%',
                }}
              >
                <i className='fa fa-times' aria-hidden='true'></i>
              </span>
            </div>
          )}
          {!listData.dynamicListImage && <ErrorMessage error={'Choose An Image'} />}
          {!horizontalImagePresent && <ErrorMessage error={'Select a Horizontal Image'} />}
          {!requiredImageSize && <ErrorMessage error={'Image size should not be more than 2mb'}/>}
        </div>
      </div>
    </div>
  )
}

export default DynamicListMainFieldsUi
